import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components';
import { dialogInputClass, dialogLabelClass } from './akteDialogFields';
import { segmentsOf } from './akteFolderRules';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  folderPath: string;
  onRename: (newName: string) => Promise<void>;
}

/** „Ordner umbenennen" — verschiebt den ganzen Subtree (nur Custom-Ordner, §4.8). */
export function RenameFolderDialog({ open, onOpenChange, folderPath, onRename }: Props) {
  const current = segmentsOf(folderPath).pop() ?? '';
  const [name, setName] = useState(current);
  const [busy, setBusy] = useState(false);

  async function submit() {
    const clean = name.trim();
    if (!clean || clean === current) return;
    setBusy(true);
    try {
      await onRename(clean);
      onOpenChange(false);
    } catch {
      // Fehler-Toast kommt aus der Mutation; Dialog bleibt offen.
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Ordner umbenennen</DialogTitle>
          <DialogDescription>Alle Dateien im Ordner werden mitverschoben.</DialogDescription>
        </DialogHeader>
        <DialogBody>
          <label htmlFor="rename-name" className={dialogLabelClass}>
            Ordnername
          </label>
          <input
            id="rename-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
            className={dialogInputClass}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
          />
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={busy}>
            Abbrechen
          </Button>
          <Button
            variant="brand"
            loading={busy}
            disabled={!name.trim() || name.trim() === current}
            onClick={submit}
          >
            Umbenennen
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
